module.exports = __webpack_public_path__ + "img/leftArrow.b20d8357.png";